import { cn } from '@/utils/cn';

interface ProgressBarProps {
  value: number;
  max?: number;
  className?: string;
  showPercentage?: boolean;
  label?: string;
}

export function ProgressBar({
  value,
  max = 100,
  className,
  showPercentage = false,
  label,
}: ProgressBarProps) {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  return (
    <div className={cn('w-full', className)}>
      {label && (
        <div className='flex justify-between items-center mb-2'>
          <span className='text-sm font-medium text-[var(--color-text)]'>
            {label}
          </span>
          {showPercentage && (
            <span className='text-sm text-[var(--color-text-secondary)]'>
              {Math.round(percentage)}%
            </span>
          )}
        </div>
      )}
      <div className='w-full bg-[var(--color-secondary)] rounded-full h-2'>
        <div
          className='bg-[var(--color-main)] h-2 rounded-full transition-all duration-300 ease-out'
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
